import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function organisationsReducer(state = initialState.organisations, action) {

    const mergeInOrganisation = (organisations, organisationUpdate) => {
        const organisationsMinusStaleData = organisations.filter(organisation => organisation.id !== organisationUpdate.id);       
        return organisationsMinusStaleData.concat(organisationUpdate);
    }

     const deleteOrganisation = (current, id) => {
        return current.filter(organisation => organisation.id !== id);
    } 


    switch (action.type) {
        case types.LOAD_ORGANISATION_SUCCESS:
        case types.UPDATED_ORGANISATION_SUCCESS:
            return mergeInOrganisation(state, action.organisation);
            case types.DELETED_ORGANISATION:      
            return deleteOrganisation(state, action.id);      
        case types.DELETED_ORGANISATION_INCOMING:       
            return deleteOrganisation(state, action.payload);    
        default:
            return state;
    }
}